import styled from 'styled-components';
import { Images } from 'util/images';

export const AppContainer = styled.div`
  background-image: url(${Images.paymentBackground});
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
`;

export const AppWrapper = styled.div`
  background-color: rgba(192, 192, 192, 0.7);
  border-radius: 15px;
  padding: 15px;
  max-width: 80%;
`;
